import React from 'react';

const StatusKey = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  const statuses = [
    {
      name: 'Open',
      description: 'Transaction has just been created. Status while car is parked in garage.',
      color: 'bg-cyan-500'
    },
    {
      name: 'Requested',
      description: 'Customer has requested car. Transaction is awaiting payment.',
      color: 'bg-yellow-800'
    },
    {
      name: 'Make Ready',
      description: 'Customer has paid for transaction. Car can be pulled and made ready for customer retrieval.',
      color: 'bg-red-500'
    },
    {
      name: 'Car Ready',
      description: 'Car has been pulled and is awaiting customer.',
      color: 'bg-green-500'
    },
    {
      name: 'Closed',
      description: 'Car has been retrieved by customer.',
      color: 'bg-accent'
    }
  ];

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg px-4 py-2 md:p-6 max-w-lg w-full mx-4">
        <div className="flex justify-between items-center mb-4">
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700 w-full flex justify-end"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
        <div className="space-y-4">
          {statuses.map((status, index) => (
            <div key={index} className="flex flex-col items-center space-x-4">
              <div className={`${status.color} w-full h-8 rounded flex items-center justify-center text-secondary font-bold mb-3`}>
                {status.name}
              </div>
              <div className="flex-1">
                <p className="text-black font-bold text-center text-base md:text-large lg:text-xl leading-4">{status.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default StatusKey;
